import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

// Initialize the moment-duration-format plugin
momentDurationFormatSetup(moment);

function durationDate (date) {
  const currentDate = new Date();
  const diff = currentDate.getTime() - moment(date).valueOf();
  const msPerMinute = 60;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;
  const elapsed = diff / 1000;

  if (elapsed < msPerMinute) {
    const time = Math.round(elapsed / 1000);
    return moment.duration(time, 'seconds').format('s [seconds] ago');
  } else if (elapsed < msPerDay) {
    const time = elapsed / msPerHour;
    if (time > 1 && time < 2) {
      return moment.duration(time, 'hours').format('h [hour] ago');
    } else if (time < 1) {
      const time = elapsed / msPerMinute;
      if (time < 2) {
        return moment.duration(time, 'minutes').format('m [minute] ago');
      }
      return moment.duration(time, 'minutes').format('m [minutes] ago');
    }
    return moment.duration(time, 'hours').format('h [hours] ago');
  } else if (elapsed < msPerMonth) {
    const days = Math.round(elapsed / msPerDay);
    if (days % 7 === 0) {
      const time = Math.round(days / 7);
      if (time < 2) {
        return moment.duration(time, 'weeks').format('w [week] ago');
      }
      return moment.duration(time, 'weeks').format('w [weeks] ago');
    }
    const time = elapsed / msPerDay;
    if (time < 2) {
      return 'yesterday';
    } else {
      return moment.duration(time, 'days').format('d [days] ago');
    }
  } else if (elapsed < msPerYear) {
    const time = elapsed / msPerMonth;
    if (time < 2) {
      return moment.duration(time, 'months').format('M [month] ago');
    }
    return moment.duration(time, 'months').format('M [months] ago');
  } else {
    const time = elapsed / msPerYear;
    if (time < 2) {
      return moment.duration(time, 'years').format('y [year] ago');
    }
    return moment.duration(time, 'years').format('y [years] ago');
  }
}
export default {
  durationDate
};
